import { api } from './api.js';
import { ENDPOINTS } from '../config/endpoints.js';

export const consultationService = {
  /**
   * Busca a lista de atendimentos
   */
  async getConsultations(page = 1, limit = 20) {
    try {
      const response = await api.get(`${ENDPOINTS.CONSULTATIONS_LIST}?page=${page}&limit=${limit}`);
      return {
        success: true,
        consultations: response.data.response || [],
        total: response.data.total || 0,
        page: response.data.page || 1,
        limit: response.data.limit || limit,
      };
    } catch (error) {
      console.error('Error fetching consultations:', error);
      return {
        success: false,
        error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao buscar atendimentos',
      };
    }
  },
};
